var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHasPaid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 140,
  height: 141,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m25.968 58.8-10.19 7.528h10.19v-7.529ZM124.221 66.328H15.777v57.027h108.444V66.328Z",
  fill: "#fff"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M124.221 66.328H15.777v57.027h108.444V66.328Z",
  fill: "url(#has-paid_svg__a)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.777 101.942v11.411H.325l15.454-11.411Z",
  fill: "url(#has-paid_svg__b)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M124.223 101.941v11.412h15.453l-15.453-11.412Z",
  fill: "url(#has-paid_svg__c)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M40.425 48.148h59.15l24.647 18.18H22.229s-4.976 0-7.1-2.077c3.059.111 7.021-2.63 7.021-2.63l18.275-13.473Z",
  fill: "url(#has-paid_svg__d)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M40.425 48.148h59.15l15.454 11.396s4.755 3.392 8.844 2.869c-3.169 3.915-12.029 3.915-12.029 3.915H38.935s-15.422 0-21.064-6.689c3.15.795 6.49.22 9.193-1.585l13.361-9.906Z",
  fill: "#fff"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.16,
  d: "M99.354 57.23c0 1.252-14.597 2.678-26.675 2.678-8.907 0-17.054-1.87-17.054-3.17 0-1.3 9.78-1.806 21.857-1.806s21.872 1.045 21.872 2.298Z",
  fill: "url(#has-paid_svg__e)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M77.53 42.172c0 .951-3.36 1.728-7.514 1.728-4.152 0-7.512-.777-7.512-1.728 0-.95 3.36-1.727 7.512-1.727a23.669 23.669 0 0 1 5.516.554c1.237.302 1.997.714 1.997 1.173Z",
  fill: "#fff"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M84.329 56.422a.54.54 0 0 1 0 .348c-.412 1.76-6.689 3.17-14.376 3.17-7.687 0-13.98-1.379-14.391-3.17a.46.46 0 0 1 0-.349l.253-.538 6.562-13.71c0 .95 3.36 1.727 7.513 1.727 4.152 0 7.512-.776 7.512-1.727l6.546 13.71.38.538Z",
  fill: "url(#has-paid_svg__f)"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M15.778 77.486s-2.837 2.773-2.695 4.754c5.817-3.17 33.38-3.803 33.38-3.803H15.778v-.951Z",
  fill: "url(#has-paid_svg__g)"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M124.221 107.632a4.277 4.277 0 0 1 1.22 2.409c-1.775-1.49-21.27-1.664-21.27-1.664h20.05v-.745Z",
  fill: "url(#has-paid_svg__h)"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M124.222 72.715c.886.58 1.845 1.038 2.853 1.363-1.062.697-4.501.332-6.451.27-2.219-.08-11.253-.698-11.253-.698h14.851v-.935Z",
  fill: "url(#has-paid_svg__i)"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M15.779 105.207a3.172 3.172 0 0 1-2.045 1.03c.666.935 3.17.697 6.673.254 3.17-.397 11.713-.745 11.713-.745H15.779v-.539Z",
  fill: "url(#has-paid_svg__j)"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M101.175 95.427s19.843 1.348 25.359 3.836a6.592 6.592 0 0 0-2.251-4.897v1.061h-23.108Z",
  fill: "url(#has-paid_svg__k)"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M55.798 66.328s7.75-.286 8.733-.46c1.79-.301 13.773.46 13.773.46H55.798Z",
  fill: "url(#has-paid_svg__l)"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M66.512 101.022s2.583-.348 3.55-.57c1.79-.317 15.231.523 15.231.523l-18.781.047Z",
  fill: "url(#has-paid_svg__m)"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M120.387 82.288s-12.807-.54-14.011-.46c-1.823.111-4.755.46-4.755.46h18.766Z",
  fill: "url(#has-paid_svg__n)"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M92.254 10.886h14.534c1.155 0 2.092.936 2.092 2.092v20.51a2.092 2.092 0 0 1-2.092 2.091H92.254V10.886Z",
  fill: "url(#has-paid_svg__o)"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M103.173 3.88H70.016v25.36h33.157V3.88Z",
  fill: "url(#has-paid_svg__p)"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m83.927 21.181-2.942-2.942a1.486 1.486 0 1 1 2.101-2.1l1.892 1.89 6.934-6.934a1.486 1.486 0 0 1 2.101 2.101l-7.985 7.985c-.58.58-1.52.58-2.101 0Z",
  fill: "#fff"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "m92.254 35.579 10.92-6.34h-10.92v6.34Z",
  fill: "url(#has-paid_svg__q)"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M20.438 92.258a3.883 3.883 0 0 0-1.934 2.884c1.585-1.062 12.553-2.884 23.204-2.884h-21.27Z",
  fill: "url(#has-paid_svg__r)"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.16,
  d: "M77.528 42.173h-7.465c-.333 0-.587-.127-.587-.302 0-.174.254-.285.587-.285h7.069c.206.222.396.349.396.587Z",
  fill: "url(#has-paid_svg__s)"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M70.585 1.651v40.506h-1.157V1.65a.657.657 0 0 1 .163-.506.586.586 0 0 1 .471-.196.58.58 0 0 1 .404.233.644.644 0 0 1 .12.47Z",
  fill: "url(#has-paid_svg__t)"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.16,
  d: "M70.586 2.91v1.67c-.17.194-.369.293-.57.282-.208.011-.412-.087-.587-.283V2.911c-.038-.41.063-.82.258-1.048.194-.227.446-.227.64 0 .196.227.297.638.259 1.048Z",
  fill: "url(#has-paid_svg__u)"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M70.016 3.246a1.585 1.585 0 1 0 0-3.17 1.585 1.585 0 0 0 0 3.17Z",
  fill: "#2A2A2A"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M131.321 113.354h-47.12a1.696 1.696 0 0 0-1.585 1.172c-1.047 3.17-6.34 7.656-12.553 7.656-6.214 0-11.507-4.502-12.553-7.656a1.71 1.71 0 0 0-1.585-1.172H.325v26.722h139.349v-26.722h-8.353Z",
  fill: "#54545E"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__a",
  x1: 70.395,
  y1: 102.739,
  x2: 70.176,
  y2: 87.154,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A5A5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__b",
  x1: 30.692,
  y1: 96.178,
  x2: 12.513,
  y2: 117.643,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D8D8D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__c",
  x1: 109.308,
  y1: 96.177,
  x2: 127.487,
  y2: 117.643,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D8D8D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__d",
  x1: 70.618,
  y1: 56.966,
  x2: 70.554,
  y2: 58.188,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5E5E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B2B2B2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__e",
  x1: 84.313,
  y1: 57.436,
  x2: 100.781,
  y2: 57.436,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A5A5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5A5A5A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__f",
  x1: 60.887,
  y1: 51.033,
  x2: 89.686,
  y2: 51.033,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF4244"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8D3C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__g",
  x1: 7.124,
  y1: 79.931,
  x2: 35.42,
  y2: 73.739,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5E5E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B2B2B2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__h",
  x1: 129.641,
  y1: 108.865,
  x2: 116.071,
  y2: 106.151,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5E5E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B2B2B2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__i",
  x1: 132.67,
  y1: 73.618,
  x2: 111.896,
  y2: 71.593,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5E5E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B2B2B2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__j",
  x1: 8.298,
  y1: 106.051,
  x2: 25.24,
  y2: 104.572,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5E5E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B2B2B2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__k",
  x1: 133.983,
  y1: 97.053,
  x2: 104.544,
  y2: 85.526,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5E5E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B2B2B2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__l",
  x1: 55.718,
  y1: 66.061,
  x2: 78.225,
  y2: 66.061,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D8D8D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__m",
  x1: 66.512,
  y1: 100.709,
  x2: 85.325,
  y2: 100.709,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5E5E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B2B2B2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__n",
  x1: 105.821,
  y1: 82.049,
  x2: 109.422,
  y2: 88.537,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5E5E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B2B2B2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__o",
  x1: 97.244,
  y1: 23.264,
  x2: 104.106,
  y2: 23.235,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF4244"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8D3C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__p",
  x1: 70.016,
  y1: 16.56,
  x2: 103.173,
  y2: 16.56,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF4244"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8D3C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__q",
  x1: 97.722,
  y1: 31.33,
  x2: 97.674,
  y2: 33.65,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF4244"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8D3C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__r",
  x1: 11.72,
  y1: 93.741,
  x2: 34.7,
  y2: 88.869,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5E5E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B2B2B2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__s",
  x1: 70.713,
  y1: 41.877,
  x2: 79.953,
  y2: 41.877,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A5A5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5A5A5A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__t",
  x1: 70.008,
  y1: 42.24,
  x2: 69.75,
  y2: 2.472,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A5A5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "has-paid_svg__u",
  x1: 69.997,
  y1: 4.495,
  x2: 70.082,
  y2: 3.397,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A5A5A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5A5A5A",
  stopOpacity: 0
})))));
export default SvgHasPaid;